export const getIsDefaultActiveStyle = (
  active: boolean,
  checkbox: boolean,
  radio: boolean
) => active && !checkbox && !radio;
